import IframeService from '../abstract/IframeService';
import IframeServiceInjectObject from './IframeServiceInjectObject';

/**
 * The purpose of this class is to inject the iframe ref to all the services that need it.
 */
class IframeServiceInjector {
  private services: Map<string, IframeServiceInjectObject> = new Map();

  public addService(service: IframeService, name: string, persistant = false) {
    this.services.set(
      name,
      new IframeServiceInjectObject(name, persistant, service)
    );
  }

  //@TODO - make this function async
  public getService<T>(name: string): T {
    return this.services.get(name)?.getService() as T;
  }

  public reset() {
    for (const service of this.services.values()) {
      if (!service.isPersistant()) {
        this.services.delete(service.getName());
      }
    }
  }

  public injectIframe(iframe: HTMLIFrameElement) {
    this.services.forEach((service) => {
      service.getService().injectIframe(iframe);
    });
  }
}

export default new IframeServiceInjector();
